import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from 'axios';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../css/Ind-details.css"; // Import the separate CSS file
import Navbar from "./Navbar";
import TitleBar from "./TitleBar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../Services/Api";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
const PricingPage = (props) => {
    const { data, image } = props;
    const [pipDetails, setPipDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    // 🔹 Add this function at the top of your component
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date)) return dateString; // in case it's not a valid date
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        axios.get(`${BaseUrl}/reg-pip`, {
            withCredentials: true, // 👈 ensures cookies are sent
        })
            .then(response => {
                const data = response.data;
                // console.log(data);

                const dataWithSno = data.map((item, index) => ({
                    ...item,
                    id: index + 1
                }));

                setPipDetails(dataWithSno);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    const handleRedirect = () => {
        navigate('/set-price');
    }

    // 🔹 UPDATED: Added capitalization in cell renderers
    const capitalize = (text) => {
        if (!text) return "N/A";
        return text
            .toString()
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
    };

    const columns = [
        {
            name: "S.No",
            selector: (row) => row.id,
            sortable: true,
            width: "80px"
        },
        {
            name: "Full Name",
            selector: (row) => row.fullname,
            sortable: true,
            cell: row => <div className="name-cell">{capitalize(row.fullname)}</div>
        },
        {
            name: "Website",
            selector: (row) => row.website,
            sortable: true,
            cell: row => <div className="email-cell">{capitalize(row.website)}</div>
        },
        {
            name: "Address",
            selector: (row) => row.address,
            sortable: true,
            cell: row => <div className="address-cell">{capitalize(row.address)}</div>
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            cell: row => <div className="email-cell">{row.email ? row.email : "N/A"}</div>
            // 🔹 Emails usually better in UPPERCASE
        },
        {
            name: "Phone",
            selector: (row) => row.phone,
            sortable: true,
            cell: row => <div className="phone-cell">{row.phone || "N/A"}</div>
        },
        {
            name: "Reg Date",
            selector: (row) => row.timestamp || "N/A",
            sortable: true,
            cell: row => <div className="date-cell">{formatDate(row.timestamp)}</div>
        },

    ];

    const [filterText, setFilterText] = useState("");

    const filteredData = pipDetails.filter(
        (item) =>
            (item.fullname && item.fullname.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.email && item.email.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.website && item.website.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.address && item.address.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.phone && item.phone.toString().includes(filterText))
    );

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData.map(item => ({
            "S.No": item.id,
            "Full Name": capitalize(item.fullname),
            "Website": capitalize(item.website),
            "Address": capitalize(item.address),
            "Email": item.email ? item.email : "N/A",
            "Phone": item.phone,
            "Reg Date": formatDate(item.timestamp)
        })));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "PIP Details");
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(blob, "pip_details.xlsx");
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.text("PIP Details Table", 14, 10);

        const tableColumn = ["S.No", "Full Name", "Website", "Address", "Email", "Phone", "Reg Date"];
        const tableRows = filteredData.map((item) => [
            item.id,
            capitalize(item.fullname),
            capitalize(item.website),
            capitalize(item.address),
            item.email ? item.email : "N/A",
            item.phone,
            formatDate(item.timestamp)  // ✅ formatted date
        ]);

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            styles: {
                fontSize: 8,
                cellPadding: 2
            },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 30 },
                2: { cellWidth: 30 },
                3: { cellWidth: 40 },
                4: { cellWidth: 40 },
                5: { cellWidth: 25 },
                6: { cellWidth: 25 }
            }
        });

        doc.save("pip_details.pdf");
    };

    return (
        <>
            <Navbar />
            <div className="user-table-container">
                <h3 style={{textAlign:'center',fontWeight:'bold'}}>Pricing Structure</h3>

                <div className="user-table-header">
                    <div className="user-table-controls">
                        <div className="user-table-search">
                            <input
                                type="text"
                                placeholder="Search by name, email, phone etc..."
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                                className="user-search-input"
                            />
                        </div>

                        <div className="user-table-export">
                            <button onClick={handleRedirect} className="export-btn export-excel">
                                <span>  <PersonAddAltIcon style={{ marginRight: '2px', marginLeft: '-5px' }} /> Add PIP</span>
                            </button>
                            <button onClick={exportToExcel} className="export-btn export-excel">
                                <span>  <FileUploadIcon style={{ marginRight: '-2px', marginLeft: '-5px' }} /> Export to Excel</span>
                            </button>
                            <button onClick={exportToPDF} className="export-btn export-pdf">
                                <span>  <FileUploadIcon style={{ marginRight: '-2px', marginLeft: '-5px' }} /> Export to PDF</span>
                            </button>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="spinner"></div>
                        <p>Loading PIP details...</p>
                    </div>
                ) : (
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        highlightOnHover
                        striped
                        customStyles={{
                            head: {
                                style: {
                                    fontSize: '15px',
                                },
                            },
                            headRow: {
                                style: {
                                    backgroundColor: '#ABBAF6',
                                    borderTop: '1px solid #e0e0e0',
                                    borderBottom: '1px solid #e0e0e0',
                                },
                            },
                            headCells: {
                                style: {
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    paddingLeft: '12px',
                                    paddingRight: '12px',
                                },
                            },
                            cells: {
                                style: {
                                    paddingLeft: '12px',
                                    paddingRight: '12px',
                                },
                            },
                            rows: {
                                style: {
                                    fontSize: '14px',
                                    '&:hover': {
                                        backgroundColor: '#f8f9fa',
                                    },
                                },
                                stripedStyle: {
                                    backgroundColor: '#f8fafc',
                                }
                            },
                            pagination: {
                                style: {
                                    borderTop: 'none',
                                },
                            },
                        }}
                    />
                )}
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default PricingPage;
